previousQueryRef